import React, { FC } from 'react';
import { View } from 'react-native';
import { scale as initialScale } from '@components/frame';
import Svg, { SVGIconProps } from '@styles/icons/svg';
import { isWeb } from '@helpers';
import TouchableElement from '@components/common/touchableElement';
import { SimpleOnPress } from '@interfaces/base';
import { PanelProps } from '@components/operatorPanel/components/panel';

export enum CounterButtonType {
  ADD = 'add',
  SUBTRACT = 'subtract',
}

type IconConfig = Record<CounterButtonType, Omit<SVGIconProps, 'C'>>;

interface CounterButtonProps extends SimpleOnPress, Pick<PanelProps, 'CC' | 'scale'> {
  type: CounterButtonType;
  size?: number;
  shouldDisplay: boolean;
}

const CounterButton: FC<CounterButtonProps> = ({ type, size = 90, CC, onPress, shouldDisplay, scale = initialScale, }) => {
  const iconsConfig: IconConfig = {
    [CounterButtonType.SUBTRACT]: {
      icon: 'minus',
      width: scale(50),
      height: scale(12),
      preserveAspectRatio: 'none',
      transform: 'translate(0, 0.5)',
      color: 'black',
    },
    [CounterButtonType.ADD]: {
      icon: 'plus',
      width: scale(50),
      height: scale(50),
      color: 'black',
    },
  };

  const iconConfig = iconsConfig[type];

  if (!iconConfig) return null;

  return (
    <TouchableElement onPress={onPress}>
      {() => (
        <View
          style={[
            {
              width: scale(size),
              height: scale(size),
              borderRadius: scale(size),
              boxShadow: '0px 7.5px 15px rgba(0, 0, 0, 0.5)',
              backgroundColor: CC('Label/Dark/AlwaysLight Primary'),
              justifyContent: 'center',
              alignItems: 'center',
              opacity: shouldDisplay ? 1 : 0,
            },
            isWeb && { cursor: 'pointer' },
          ]}
        >
          <Svg {...iconConfig} />
        </View>
      )}
    </TouchableElement>
  );
};

export default CounterButton;
